export const SEARCHABLE_FIELDS = ["id", "case_id"];